module.exports = "/_next/static/images/217927181e1e8664860d373800e6a3fd-stapler@desktop1024.jpg.webp";